import { override } from 'flarum/common/extend';
import Drawer from 'flarum/common/utils/Drawer';

export default () => {
  override(Drawer.prototype, 'show', function (original) {
    if (this.isOpen()) {
      this.hide();
      return;
    }

    return original();
  });
}
